import type { Chat } from '@trinity/chat';
import { ChatInstanceItemType } from '@trinity/chat';
import { FileUploadItem } from './Item.FileUpload';
import { QueryItem } from './Item.Query';

type Props = {
  canRegenerate: boolean;
  item: Chat.InstanceItem;
};

export const ChatItem = ({ canRegenerate, item }: Props) => {
  switch (item.type) {
    case ChatInstanceItemType.Query: {
      return <QueryItem canRegenerate={canRegenerate} item={item} />;
    }

    case ChatInstanceItemType.FileUpload:
      return <FileUploadItem item={item} />;

    default:
      return null;
    // throw new UnreachableCaseError(item);
  }
};
